import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import { AllergyStore, IServerAllergy } from './types'

export const useAllergyStore = create<AllergyStore>()(
  devtools(set => ({
    getUserAllergies: async (userId: number) => {
      try {
        const endpoint = `/user/${userId}/allergies`
        const response = await http.get(endpoint)

        const allergies = response.map((allergy: IServerAllergy) => ({
          id: allergy.id,
          description: allergy.description,
          drugName: allergy.drug_name,
          drugForm: allergy.form,
          createdAt: new Date(allergy._created),
          originUserId: allergy.origin_user_id
        }))

        return allergies
      } catch (error) {
        console.error('Error fetching allergies:', error)
        return null
      }
    },
    addUserAllergy: async (userId, allergy) => {
      try {
        const endpoint = `/user/${userId}/allergies`
        const response = await http.post(endpoint, {
          description: allergy.description,
          drug_name: allergy.drugName,
          form: allergy.drugForm
        })

        console.log('data', response)
        return {
          success: response.success,
          errorMessage: response.errorMessage
        }
      } catch (error) {
        console.error('Error adding allergy:', error)
        return {
          success: false,
          errorMessage: error?.response?.data?.error || 'Something went wrong'
        }
      }
    },
    deleteUserAllergy: async (userId, id) => {
      try {
        const endpoint = `/user/${userId}/allergies/${id}`
        await http.delete(endpoint)
      } catch (error) {
        console.error('Error deleting allergy:', error)
      }
    }
  }))
)
